import styled, { } from 'styled-components';

export const DivisorWrapper = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: ${props => props.theme.colors[props.color]};
  position: absolute;
  top: ${props => props.top};
  left: ${props => props.left};
  display: none;
  ${props => props.theme.mediaQueries.phone}{
    display: block;
  };
`;
